import { FC } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import ProductHeader from '../ProductHeader';
import styled from './index.module.scss';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { useProductList } from '@/components/MembersDay/utils';
import { IProductProps } from '@/components/MembersDay/type';
import getLocal from '@/app/utils/getLocal';
import BigCard from './BigCard';
import SmallCard from './SmallCard';
import { useLang } from '@/i18n';

const MixProduct: FC<IProductProps> = ({ module, icon, title, desc, id }) => {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const { productList } = useProductList(module, locale);
    const { isLogin } = useMembersStore();

    if (!productList || productList.length < 1) return <></>;

    return (
        <div className={`${styled.MixProduct}`} id="activity-HotBundles">
            <ProductHeader icon={icon} title={title} desc={desc} />
            <div className="product_box">
                <BigCard title={title} data={productList[0]} left skipLogin={true} entry_position={4} />
                <div className="list_box">
                    {productList
                        .filter((_item, index) => index > 0)
                        .map((item) => (
                            <SmallCard key={item.variantId} title={title} data={item} entry_position={4} />
                        ))}
                </div>
            </div>
        </div>
    );
};

export default MixProduct;
